import { render, staticRenderFns } from "./HighAssetsRedelegation.vue?vue&type=template&id=8f4bf5bc"
import script from "./HighAssetsRedelegation.vue?vue&type=script&lang=js"
export * from "./HighAssetsRedelegation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports